import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl, getFormArray } from '@shared/helpers/form.helper';
import { cloneDeep } from 'lodash-es';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { Revisione53DatiBusinessSelectors } from '../../../store/selectors/dati-business.selectors';
import { MyAllElemConsiglioAmministrazioneEntity, MyVerbale } from '../../../models/interfaces/revisione.interface';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { withCkNormeGuard } from '../common/operators/with-ck-norme-guard.operator';
import { calcolaScadenzaOrganoAmministrativo } from '../common/helpers/norme-store-update.helper';

const AMM_CTRL_PATH = 'my_SezioneI__Rilevazione.my_AmministrazioneControllo';

export const my_AllConsAmmDataElezioneListenerHelper = (form: FormGroup, store: Store<Revisione53State>, valoreNormaAttesa: CkNormeValues) => {
    const componentiConsiglioAmministrazioneControl = getControl(form, `${AMM_CTRL_PATH}.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione`);

    return componentiConsiglioAmministrazioneControl.valueChanges
        .pipe(withChangeDebounced(componentiConsiglioAmministrazioneControl), withCkNormeGuard(form, valoreNormaAttesa))
        .subscribe(() => {
            calcolaScadenzaOrganoAmministrativo(form, store);
        });
};

export const my_AllConsAmmCaricaListenerHelper = (form: FormGroup, store: Store<Revisione53State>, valoreNormaAttesa: CkNormeValues) => {
    const componentiConsiglioAmministrazioneArray = getFormArray(form, `${AMM_CTRL_PATH}.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione`);

    return componentiConsiglioAmministrazioneArray.valueChanges
        .pipe(withChangeDebounced(componentiConsiglioAmministrazioneArray), withCkNormeGuard(form, valoreNormaAttesa))
        .subscribe((componentiConsiglioAmministrazione: MyAllElemConsiglioAmministrazioneEntity[] = []) => {
            componentiConsiglioAmministrazione.forEach((componenteConsiglioAmministrazione, index) => {
                const codiceCarica = componenteConsiglioAmministrazione.my_AllConsAmmCarica;
                store
                    .select(Revisione53DatiBusinessSelectors.getAllConsAmmCaricaSpec(codiceCarica))
                    .pipe(take(1))
                    .subscribe((carica) => {
                        const componenteConsiglioAmministrazioneGroup = componentiConsiglioAmministrazioneArray.at(index) as FormGroup;
                        const descrizioneCaricaControl = getControl(componenteConsiglioAmministrazioneGroup, 'my_AllConsAmmCaricaDesc');

                        descrizioneCaricaControl.patchValue(carica?.descrizione ?? '', { emitEvent: false });

                        updateVerbaleOnStore(store, (myVerbale) => {
                            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                            myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione =
                                componentiConsiglioAmministrazioneArray.value;
                            return myVerbaleClone;
                        });
                    });
            });
        });
};

export const my_AmmUnicoCaricaListenerHelper = (form: FormGroup, store: Store<Revisione53State>, valoreNormaAttesa: CkNormeValues) => {
    const amministratoriUniciArray = getFormArray(form, `${AMM_CTRL_PATH}.my_AllAmminUnico`);
    amministratoriUniciArray.controls.forEach((amministratoreUnicoGroup: FormGroup) => {
        const caricaAmministratoreUnicoControl = getControl(amministratoreUnicoGroup, 'my_AllAmmUnCarica');
        const descrizioneCaricaAmministratoreUnicoControl = getControl(amministratoreUnicoGroup, 'my_AllAmmUnCaricaDesc');

        caricaAmministratoreUnicoControl.valueChanges
            .pipe(withChangeDebounced(caricaAmministratoreUnicoControl), withCkNormeGuard(form, valoreNormaAttesa))
            .subscribe((caricaAmministratoreUnico) => {
                const descrizioneCarica = !isNilOrEmpty(caricaAmministratoreUnico) ? 'AMMINISTRATORE UNICO' : '';
                descrizioneCaricaAmministratoreUnicoControl.patchValue(descrizioneCarica, { emitEvent: false });

                updateVerbaleOnStore(store, (myVerbale) => {
                    const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                    myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllAmminUnico = amministratoriUniciArray.value;
                    return myVerbaleClone;
                });
            });
    });
};
